import * as React from 'react';
import { EMAIL_SUFFIX } from '@/components/project/Config/Config';
import { checkProjectEmail } from '@/reducers/project/project/project.service';
import {
  maxLengthRule,
  validCFOEmailRule,
  validEmailInputRule,
  createValidationRule,
} from '@/util/form/form.rules';

export const confirmationModal = {
  title: 'Confirm Account Creation',
  body: (accountName, email) => (
    <React.Fragment>
      <p>
        You are about to create an account for <strong>{accountName}</strong>{' '}
        with assigned account email below:
      </p>
      <p class="account-email">{`${email}`}</p>
      <p>
        Please ensure this is correct. Account emails can no longer be edited
        upon confirmation.
      </p>
    </React.Fragment>
  ),
};

export function emailExistsRule(message) {
  return createValidationRule(
    'emailExists',
    message,
    async (inputValue, inputObj) => {
      const currentEmail = `${inputObj.email.defaultValue}@${EMAIL_SUFFIX}`;
      const inputEmail = `${inputValue}@${EMAIL_SUFFIX}`;

      if (currentEmail === inputEmail) {
        return true;
      }

      return await checkProjectEmail(inputEmail);
    }
  );
}

export const saveCompanyForm = {
  email: {
    validationRules: [
      maxLengthRule('email', 300),
      validEmailInputRule('email'),
      validCFOEmailRule('email'),
      emailExistsRule('Email already assigned to another account!'),
    ],
  },
};
